import { setLocalMessage, getLocalMessage} from "./localMessage";
const BASEURL_KEY = 'BaseURL'
const USERNAME_KEY = 'UserName'

export function setBaseURL(baseURL) {
    return setLocalMessage(BASEURL_KEY, baseURL);
}

export function getBaseURL() {
    return getLocalMessage(BASEURL_KEY);
}

export function setUserName(userName) {
    return setLocalMessage(USERNAME_KEY, userName);
}

export function getUserName() {
    return getLocalMessage(USERNAME_KEY);
}